module.exports = __webpack_public_path__ + "img/mastercard-sq.166ec609.png";